import React from "react";

const Strings2HtmlListItems = ({ value, separator = "," }) => {
  const elements = (value || "").split(separator);

  return (
    value && (
      <p>
        {elements.map((item) => (
          <li>{item}</li>
        ))}
      </p>
    )
  );
};

export default Strings2HtmlListItems;
